import React, { useCallback, useContext, useState } from 'react';
import { Grid, IconButton, Stack, Typography, Box, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { LanguageContext } from '../../../../../../../libs/Context';
import { MdOutlineFileUpload } from 'react-icons/md';

import { useSelector } from 'react-redux';
import { newUploadFiles } from '../../../../../../../libs/HelperContent';
import { toast } from 'react-toastify';
import { useDropzone } from 'react-dropzone';
import { RiDeleteBinLine } from 'react-icons/ri';

const BannerImages = (props) =>
{
	const { bannerImage, handleSet } = props;
	const { language } = useContext(LanguageContext);
	const userData = useSelector((state:any) => state.mysession.session);
	const images = [
		{ url: `${process.env.REACT_APP_S3_CLOUDFRONT}/public/webinar/defaultbanner/banner1.jpg`, key: 'public/webinar/defaultbanner/banner1.jpg', name: 'banner1', size: 0, mediaType: 'image', type: 'image/jpg' },
		{ url: `${process.env.REACT_APP_S3_CLOUDFRONT}/public/webinar/defaultbanner/banner2.jpg`, key: 'public/webinar/defaultbanner/banner2.jpg', name: 'banner2', size: 0, mediaType: 'image', type: 'image/jpg' },
		{ url: `${process.env.REACT_APP_S3_CLOUDFRONT}/public/webinar/defaultbanner/banner3.jpg`, key: 'public/webinar/defaultbanner/banner3.jpg', name: 'banner3', size: 0, mediaType: 'image', type: 'image/jpg' }
	];
	const keyList = images.map((item) => item.key);
	const [ upload, setUpload ] = useState(!keyList.includes(bannerImage[0]?.key) ? bannerImage[0] : { key: '', url: '' });
	const MAX_TOTAL_SIZE = 50 * 1024 * 1024;

	const onDrop = async (fileList) =>
	{
		if (fileList.length > 0)
		{
			const folderPath = `webinar/${userData?.userId}`;

			const [ uploaded ]:any = await newUploadFiles(fileList, folderPath);

			uploaded.mediaType = 'image';

			if (uploaded)
			{
				setUpload(uploaded);
				handleSet('bannerImage', [ uploaded ]);
			}
		}
	};

	const onDropRejected = useCallback((fileRejections) =>
	{
		const errorMessages = fileRejections.map((rejection) =>
		{
			const { errors } = rejection;

			return errors.map((error) =>
			{
				switch (error.code)
				{
					case 'file-too-large':
						return language?.fileTooLarge;
					case 'file-invalid-type':
						return language?.invalidFileType;
					default:
						return language?.fileRejected;
				}
			});
		}).flat();

		toast.error(errorMessages[0], {
			position  : toast.POSITION.TOP_RIGHT,
			autoClose : 2000
		});
	}, []);

	const acceptType = {
		maxFiles : 1,
		maxSize  : MAX_TOTAL_SIZE,
		accept   : {
			'image/*' : [ '.png', '.gif', '.jpeg', '.jpg', '.webp' ]
		},
		onDrop,
		onDropRejected
	};
	const { getRootProps, getInputProps } = useDropzone(acceptType);

	const handleSelectBanner = (obj) =>
	{
		handleSet('bannerImage', [ obj ]);
	};

	const handleDelete = () =>
	{
		setUpload({ key: '', url: '' });
		handleSelectBanner(images[0]);
	};

	return (
		<Grid item xs={12} py='var(--pixel8)'>
			<Typography variant='inherit' fontSize='var(--pixel18)' fontWeight='var(--font500)' py='var(--pixel8)'>{language?.registrationBanneimage}</Typography>
			<RadioGroup
				row
				aria-labelledby='demo-controlled-radio-buttons-group'
				name='controlled-radio-buttons-group'

			>
				<Grid container>
					{images.map((image:any, index) => (
						<Grid item sm={12} md={5} p='var(--pixel8)' key={`image-${image?.key}`}>
							<Stack direction='row' onClick={() => handleSelectBanner(image)}>
								<FormControlLabel control={<Radio checked={bannerImage[0]?.key === image?.key} />} label='' />
								<Box
									alignItems='center'
									justifyContent='center'
									display='flex'
									sx={{
										cursor    : 'pointer',
										width     : '250px',
										height    : '124px',
										objectFit : 'cover',
										'& img'   : {
											width        : 'var(--percent100)',
											height       : 'var(--percent100)',
											objectFit    : 'cover',
											borderRadius : 'var(--pixel8)'
										}
									}}
								>
									<img src={`${process.env.REACT_APP_S3_BASE_URL}/${image?.key}`} alt={image?.name || 'banner image'} />
								</Box>
							</Stack>
						</Grid>
					))}
					<Grid item sm={12} md={5} p='var(--pixel8)'>
						{!upload?.key &&
						<Stack direction='row' {...getRootProps()}>
							<Radio checked={false} />
							<Box
								alignItems='center' justifyContent='center'
								display='flex'
								sx={{ border: '1px dotted var(--primaryColor)', borderRadius: 'var(--pixel4)', cursor: 'pointer', width: '250px', height: '124px' }}
							>
								<Stack spacing={0.5} direction='column' alignItems='center' justifyContent='center'>
									<MdOutlineFileUpload fontSize='var(--pixel24)'/>
									<Typography variant='inherit' fontSize={'var(--pixel16)'} fontWeight='var(--font500)' >{language?.uploadBannerimg}</Typography>
									<Typography variant='caption'>{language?.fileTypes}: JPEG, JPG, PNG</Typography>
									<Typography variant='caption'>{language?.upto} 50 MB</Typography>

								</Stack>
							</Box>
						</Stack>}
						<input type='file' style={{ display: 'none', pointerEvents: 'none' }} {...getInputProps()}/>
						{upload?.key && <Stack direction='row'>
							<FormControlLabel
								onClick={() => handleSelectBanner(upload)}
								value={bannerImage[0]?.key}
								control={<Radio checked={!keyList.includes(upload?.key) && upload?.key === bannerImage[0]?.key} />} label=''
							/>
							<Box
								onClick={() => handleSelectBanner(upload)}
								alignItems='center'
								justifyContent='center'
								display='flex'
								sx={{
									cursor    : 'pointer',
									width     : '250px',
									height    : '124px',
									objectFit : 'cover',
									position  : 'relative',
									'& img'   : {
										width        : 'var(--percent100)',
										height       : 'var(--percent100)',
										objectFit    : 'cover',
										borderRadius : 'var(--pixel8)'
									}
								}}
							>
								<Typography
									className='delete-icon'
									variant='inherit'
									color='textSecondary'
									sx={{
										display  : 'block',
										position : 'absolute',
										top      : 'var(--pixel4)',
										right    : 'var(--pixel4)',
										cursor   : 'pointer'
									}}
									onClick={(e) =>
									{
										e.stopPropagation();
										handleDelete();
									}}
								>
									<IconButton style={{ background: 'white' }}>
										<RiDeleteBinLine fontSize='var(--pixel20)' />
									</IconButton>
								</Typography>
								<img src={`${process.env.REACT_APP_S3_BASE_URL}/${upload?.key}`} alt={'img'} />
							</Box>
						</Stack>}
					</Grid>
				</Grid>
			</RadioGroup>
		</Grid>
	);
};

export default BannerImages;
